const kabob_tikkahs = [
  {
    title: "Beef Tikka kabob",
    price: "$16.99",
    tags: "Grilled Meat marinated in our special seasoning",
  },
  {
    title: "Sultani Kabob",
    price: "$18.99",
    tags: "Combo of 1 skewers of Filet Mignon & 1 skewer of Kofta Kabob",
  },
  {
    title: "Chicken Kofta Kabob",
    price: "$14.49",
    tags: "2 skewers of Chicken marinated in freshly ground spices and seasonings.",
  },
  {
    title: "Wazeri Kabob",
    price: "$18.49",
    tags: "Combination of 1 skewer of chicken breast & 1 skewre of kofta kabob",
  },
  {
    title: "Tandoori breast Kabob",
    price: "$16.49",
    tags: "Grilled spicy boneless chicken breast marinated with our speacial sauce",
  },
];

const platters = [
  {
    title: "Beef for 2",
    price: "$38.99",
    tags: "1 skewer of Beef tikka | kofta kabob | chaplee kabob | rice | 2 naans | 2 pops",
  },
  {
    title: "Chicken for 2",
    price: "$40.99",
    tags: "1 skewer of tandoori kabob | chicken chaplee | sultani kabob | rice | 2 naans | 2 pops | 1 salad",
  },
  {
    title: "family platter 1",
    price: "$65.99",
    tags: "1 Chicken Breast Kabob | Chicken Chaplee | Sultani Kabob| Rice | Salad | 5pcs Tandoori Drum Sticks | 4 Naans | 4 Pops",
  },
  {
    title: "family platter 2",
    price: "$65.99",
    tags: "1 Kofta Kabob | Beef Tikka Kabob | Chaplee Kabob | Half Chicken Kabob | Rice | Salad | 4 Naans | 4 Pops",
  },
];

const beefs = [
  {
    title: "Beef Tikka kabob",
    price: "$16.49",
    tags: "Grilled Tender Meat marinated in our special seasoning",
  },
  {
    title: "kofta Kabob",
    price: "$14.99",
    tags: "2 skewers of lean beef marinated in freshly gorund spices and seasonings",
  },
  {
    title: "Sultani Kabob",
    price: "$18.99",
    tags: "Combo of 1 skewer of beef tikka & 1 skewer of Kofta Kabob",
  },
  {
    title: "chaplee Kabob",
    price: "$14.99",
    tags: "fiery minced meat seasoned with a potent mix of dried and fresh chillies",
  },
];


const chickens = [
  {
    title: "tandoori breast kabob",
    price: "$15.99",
    tags: "grilled spicy boneless chicken breast marinated with our special sauce",
  },
  {
    title: "Chicken kofta kabob",
    price: "$14.49",
    tags: "2 Skewers Of Lean Chicken Marinated In Freshly Gorund Spices And Seasoningss",
  },
  {
    title: "chicken white breast kabob",
    price: "$15.99",
    tags: "Tender boneless chicken breast marinated with our unique blend of spices",
  },
  {
    title: "Chicken chaplee kabob",
    price: "$14.49",
    tags: "fiery minced chicken seasoned with a potent mix of dried and fresh chillies",
  },
  {
    title: "half chicken kabob",
    price: "$17.99",
    tags: "4 pieces of half chicken spicy & with bone",
  },
];
const beeffor2 = [
  {
    title: "Beef for 2",
    price: "$38.99",
    tags: "1 skewer of Beef tikka | 1 skewer of kofta kabob | 1 chaplee kabob | 1 rice | 2 naans | 1 salad | 2 pops",
  },
];


const chickensandbeef = [
  {
    title: "Wazeri Kabob",
    price: "$18.49",
    tags: "Combination of 1 skewer of chicken white breast kabob & 1 skewer of kofta kabob",
  },
  {
    title: "tandoori Wazeri",
    price: "$18.49",
    tags: "combination of 1 skewer of tandoori chicken breast kabob & 1 skewer of kofta kabob",
  },
];

const chickenfor2 = [
  {
    title: "Chicken for 2",
    price: "$40.99",
    tags: "1 skewer of tandoori kabob | 1 skewer of chicken breast kabob | 1 chicken chaplee | 1 rice | 2 naans | 2 pops | 1 salad",
  },
];


const familyplatters = [
  {
    title: "family platter 1",
    price: "$65.99",
    tags: "1 Tandoori Breast Kabob | 1 Chicken Chaplee | 1 Sultani Kabob | 8pcs Tandoori chicken wings | 1 Rice | 1 Salad  | 4 Naans | 4 Pops",
  },
  {
    title: "family platter 2",
    price: "$65.99",
    tags: "1 sultani Kabob | 1 chicken white breast kabob | 1 Chaplee Kabob | 1 Half Chicken Kabob | 1 Rice | 1 Salad | 4 Naans | 4 Pops",
  },
];

const kabobizerbeef = [
  {
    title: "beef tikka skewer ",
    price: "$9.99",
    tags: "1 piece ",
  },
  {
    title: "kofta skewer",
    price: "$5.49",
    tags: "1 piece",
  },
  {
    title: "chaplee kabob",
    price: "$5.49",
    tags: "1 piece",
  },
];

const kabobizerchicken = [
  {
    title: "chicken kofta skewer ",
    price: "$4.49",
    tags: "1 piece ",
  },
  {
    title: "tandoori chicken skewer",
    price: "$9.49",
    tags: "1 piece",
  },
  {
    title: "half chicken skewer",
    price: "$10.49",
    tags: "1 piece",
  },
  {
    title: "chicken white breast kabob skewer",
    price: "$9.49",
    tags: "1 piece",
  },
  {
    title: "chicken chaplee kabob",
    price: "$4.49",
    tags: "1 piece",
  },
];


const wings = [
  {
    title: "Chicken Wings",
    price: "$9.99",
    tags: "8 pieces ",
  },
  {
    title: "Chicken Wings with salad and naan",
    price: "$12.99",
    tags: "8 pieces",
  },
  {
    title: "Chicken Wings",
    price: "$12.99",
    tags: "12 pieces",
  },
  {
    title: "Chicken Wings with salad and naan",
    price: "$15.99",
    tags: "12 pieces",
  },
];
const qorma = [
  {
    title: "Chicken qorma plate",
    price: "$9.99",
    tags: "diced chicken breast prepared in afghan style tomato sauce",
  },
  {
    title: "Chicken qorma dinner",
    price: "$13.99",
    tags: "diced chicken breast cooked in afghan style tomato sauce. served with rice, salad & naan",
  },
];

const wraps = [
  {
    title: "Chicken kabob wrap",
    price: "$8.99",
    tags: "",
  },
  {
    title: "beef tikka warap",
    price: "$9.99",
    tags: "",
  },
  {
    title: "kofta Wings",
    price: "$7.99",
    tags: "",
  },
  {
    title: "tandoori chicekn wrap",
    price: "$9.49",
    tags: "",
  },
];

const sideorders = [
  {
    title: "naan",
    price: "$1.99",
    tags: "",
  },
  {
    title: "side of rice",
    price: "$4.99",
    tags: "",
  },
  {
    title: "Qabulee rice with raisin & carrot",
    price: "$6.99",
    tags: "",
  },
];

const salads = [
  {
    title: "ceaser salad with Chicken",
    price: "$10.49",
    tags: "",
  },
  {
    title: "ceaser salad only",
    price: "$5.99",
    tags: "",
  },
  {
    title: "Afghani salad",
    price: "$5.99",
    tags: "",
  },
];

const sauces = [
  {
    title: "white sauces",
    price: "$0.99",
    tags: "",
  },
  {
    title: "red sauces",
    price: "$0.99",
    tags: "",
  },
  {
    title: "bowl white sauces",
    price: "$4.99",
    tags: "",
  },
  {
    title: "bowl red sauces",
    price: "$4.99",
    tags: "",
  },
];
const drinks = [
  {
    title: "can drink",
    price: "$1.99",
    tags: "",
  },
  {
    title: "bottle water",
    price: "$1.49",
    tags: "",
  },
  {
    title: "barbican",
    price: "$3.49",
    tags: "",
  },
  {
    title: "rani canned peace juice",
    price: "$3.49",
    tags: "",
  },
  {
    title: "oasis juice",
    price: "$2.49",
    tags: "",
  },
];
export default {
  kabob_tikkahs,
  platters,
  beefs,
  chickensandbeef,
  chickens,
  beeffor2,
  chickenfor2,
  familyplatters,
  kabobizerbeef,
  kabobizerchicken,
  wings,
  qorma,
  wraps,
  sideorders,
  salads,
  sauces,
  drinks,
};